const lang = {
    "Kep": "QES",
    "KepNotLinked": "teie kvalifitseeritud allkiri pole veel kontoga seotud. Logige sisse nagu tavaliselt ja me seome selle.",
    "KepNewAccount": "Pole kontot? Registreeru",
    "KepLinked": "Kvalifitseeritud allkiri seoti kontoga",
    "KepLinkFailed": "Kvalifitseeritud allkirja sidumine ebaõnnestus. Logige sellega uuesti sisse ja me seome selle",
    "KepFile": "Võtmefail",
    "ErrorKepLogin": "Kvalifitseeritud allkirjaga sisselogimine ebaõnnestus",
    "EnterWidth": "Sisene:",
    "Registration": "Registreeri",
    "enter": "Tulla sisse",
    "EntrWidthEmailOrPhone": "Logi sisse e-posti või telefoni teel",
    "login": "Volitamine",
    "NoAkkGoReg": "Registreeru",
    "Password": "Parool",
    "Name": "Nimi",
    "LastName": "Perekonnanimi",
    "Phone": "Registreerimiseks sisestage oma telefoninumber",
    "Email": "Mail",
    "RepeatPassword": "Korda salasõna",
    "Сancel": "Tühista",
    "Save": "Salvesta",
    "Language": "Keel",
    "ConfirmThisMail": "Teie e-post on kinnitatud",
    "Saved": "Salvestatud",
    "Error": "Viga",
    "FillInAllTheFields": "Täitke kõik väljad",
    "Next": "Edasi",
    "MinPassLength": "Parooli minimaalne pikkus 4 tähemärki",
    "ForgotYourPassword": "Unustasid salasõna",
    "RestorePassword": "Palun määrake uus parool.",
    "UserMustBeRegistered": "Kasutaja peab olema registreeritud",
    "Confirm": "Kinnita",
    "WrongFormat": "Vale formaat",
    "WrongPassword": "vale salasõna",
    "WrongLoginOrPassword": "vale sisselogimine või parool",
    "PhoneAlreadyRegistered": "Telefon juba registreeritud",
    "EmailAlreadyRegistered": "Post juba registreeritud",
    "FillInTheFieldsCorrectly": "Täitke väljad õigesti",
    "ThisAccountDoesNotExist": "Seda kontot pole olemas",
    "LinkIsNotValid": "Link ei kehti",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Määratud kasutajanimele on saadetud sõnum",
    "IncorrectCaptcha": "vale captcha",
    "CaptchaIsNotValid": "Captcha ei kehti enam",
    "EnterCaptcha": "Sisestage captcha",
    "EnterSMS": "Sisestage kood SMS-ist",
    "SMSCodeIsNoLongerValid": "SMS kood ei kehti enam",
    "SMSCodeIsIncorrect": "SMS-kood on vale",
    "MailNotVerifiedLinkTimedOut": "Post pole kinnitatud, link aegunud",
    "DemoLogin": "Demo sisselogimine",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Kas olete kindel, et soovite selle proovimiseks siseneda <b> demosse </b> ?",
    "FillInAdditionalInformation": "Täitke lisateave",
    "ToCompleteRegistration": "Registreerimise lõpetamiseks",
    "LinkThirdPartyServices": "Linkige kolmandate osapoolte teenused",
    "Complete": "Lõpetama",
    "AccountAlreadyLinked": "Konto on juba lingitud",
    "AccountNotRegistered": "Konto registreerimata",
    "NotMyNumber": "Mitte minu number",
    "Back": "tagasi",
    "numberOfAttemptsToCheckAuth": "Sisselogimiskatsete arv:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Vale parool, sisselogimiskatsete arv:",
    "TryAgainAfterMinute": "Palun proovige uuesti 2 minuti pärast",
    "Help": "Toetus",
    "y": "Jah",
    "n": "Mitte",
    "doYouConfirmEmail": "Kas olete kindel, et soovite oma e-posti aadressi muuta?",
    "success": "Edukalt",
    "goToAutorize": "Minge autoriseerimisse",
    "UserEmailAlreadyExists": "Selle e-posti aadressiga kasutaja on juba olemas",
    "UserPhoneAlreadyExists": "Selle telefoninumbriga kasutaja on juba olemas",
    "TermOfUse": "Kasutustingimused",
    "PrivacyPolicy": "Privaatsuspoliitika",
    "accountNotRegistered": "konto registreerimata",
    "wantToReg": "Kas soovite registreeruda?",
    "weSuccessChangeYouEmail": "Oleme edukalt muutnud teie e-posti aadressi",
    "youCanCloseThisWindow": "Saate selle akna sulgeda",
    "countryConfirm": "Riigi kinnitus",
    "EmailAlreadyTied": "Mail on juba lingitud teise kontoga",
    "areYourCountry": "kas see on sinu riik?",
    "EmergencyEntrance": "Vana volitus",
    "enterCorrectNumber": "Sisestage number rahvusvahelises vormingus",
    "thisPhoneRegister": "See telefoninumber on juba süsteemis registreeritud",
    "wantUsePhoneForAuth": "Kas soovite selle telefoninumbriga sisse logida?",
    "ok": "olgu",
    "regAgree": "Konto registreerimisega nõustun",
    "wantBind": "Soovite teenusesse sisse logida ja linkida",
    "bind": "siduda",
    "yoursMailBinded": "Teie e-post on olemasoleval kontol",
    "wantUsePhoneAndBind": "juba süsteemis registreeritud",
    "notGetDataFromApple": "Apple'ilt andmete vastuvõtmine ebaõnnestus",
    "ErrorAppleLogin": "Viga Apple'i kaudu autoriseerimisel",
    "ErrorGoogleLogin": "Viga Google'i kaudu autoriseerimisel",
    "ErrorTelegramLogin": "Telegrami kaudu sisselogimisel tekkis viga",
    "ErrorFacebookLogin": "Viga Facebooki kaudu sisselogimisel",
    "EMailOrPhone": "Sisestage kehtiv telefoninumber või e-posti aadress.",
    "withoutName": "Ei mingit nime",
    "goToCabinet": "Kontorisse",
    "Logout": "Lõpeta seanss",
    "creationDate": "Loomise kuupäev",
    "preparingCompany1": "Loome teie ettevõtet, palun andke meile hetk...",
    "preparingCompany2": "Valmistame ette liidest kaupade ja teenuste haldamiseks...",
    "preparingCompany3": "Tegeleme mugava finantsarvestuse kallal...",
    "preparingCompany4": "Teeme lõplikke seadistusi, peaaegu valmis...",
    "companyBlocked": "See ettevõte on passiivne",
    "youBlockedInComp": "Kasutaja pole aktiivne, sisselogimine pole võimalik",
    "loginTitle": "Kõik, mida ettevõte vajab, ühes kohas",
    "loginDescr": "Automatiseerimine kauplustele, kohvikutele, kullerteenustele, restoranidele, ladudele, tootmisele või teenustele",
    "NoAkkGoRegText": "Sul pole kontot?",
    "LoginPlaceholder": "Palun esitage vajalik teave",
    "loginText": "Kas sul on juba konto?",
    "and": "Ja",
    "AcceptTheTerms": "Palun nõustuge privaatsuspoliitika ja kasutustingimustega",
    "CountryPhoneFormat": "Kui see ei ole teie riik, siis palun kontrollige, kas olete oma telefoninumbri sisestanud õiges rahvusvahelises vormingus.",
    "SaveNewPassword": "Salvesta uus parool"
}

export default function() {
    return lang;
}